import { Box, styled, Theme, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const AccountInfoWrapper = styled(Box)`
  border-radius: ${({ theme }) => theme.borders.borderRadius.lg_8};
  background: ${({ theme }) => theme.palette.background.bgMenuPrimary};
`;

export const NotificationWrapper = styled(Box)<{ isNew: boolean }>(
  ({ theme, isNew }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: pxToRem(8),
    background: isNew
      ? theme.palette.background.bgPrimary
      : theme.palette.colorsBase.blue_1,
    padding: pxToRem(12),
    color: isNew
      ? theme.palette.text.textPrimary
      : theme.palette.text.textWhite,
    borderRadius: pxToRem(8),
    cursor: "pointer",
  })
);

export const NotificationTitle = styled(Typography)<{ isNew: boolean }>(
  ({ theme, isNew }) => ({
    fontSize: pxToRem(16),
    fontWeight: 600,
    color: isNew
      ? theme.palette.text.textPrimary
      : theme.palette.text.textWhite,
    maxWidth: "85%",
  })
);

export const ListNotificationWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(12),
  backgroundColor: theme.palette.background.bgMenuBase,
  padding: pxToRem(16),
  borderRadius: `0 0 ${pxToRem(4)} ${pxToRem(4)}`,
  width: pxToRem(350),
}));

export const NotiDateTime = styled(Typography)<{ isNew: boolean }>(
  ({ theme, isNew }) => ({
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: isNew
      ? theme.palette.text.textSecondary
      : theme.palette.text.textDisable,
    paddingRight: pxToRem(16),
  })
);

export const NotificationLabel = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(14),
  fontWeight: 400,
  color: theme.palette.text.textWhite,
  lineHeight: pxToRem(20),
}));

export const NotificationHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.bgMenuBase2,
  color: theme.palette.text.textWhite,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${pxToRem(16)} ${pxToRem(20)}`,
  borderRadius: `${pxToRem(4)} ${pxToRem(4)} 0 0`,
}));

export const NotificationHeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(16),
  fontWeight: theme.typography.fw_semibold_600,
}));

export const iconNotificationColor = (
  theme: Theme,
  status: "leave" | "late" | "read"
) => {
  switch (status) {
    case "leave":
      return theme.palette.icon.icBrand;
    case "late":
      return theme.palette.icon.icWarning;
    case "read":
      return theme.palette.icon.icPositive;
    default:
      return theme.palette.colorsBase.gray_3;
  }
};

export const NotificationIconWrapper = styled(Box)<{
  isNew: boolean;
  type: string;
}>(({ theme, type, isNew }) => ({
  svg: {
    path: {
      fill: !isNew
        ? theme.palette.icon.icLight
        : iconNotificationColor(theme, type as "leave" | "late" | "read"),
    },
  },
}));
